/**
 *
 * TpIcapCardHeader
 *
 */

import { CardHeader } from 'reactstrap';
import styled from 'styled-components';

const TpIcapCardHeader = styled(CardHeader)`
  border-radius: 0 !important;
  background-color: white !important;
  border-bottom: 0 !important;
`;

export default TpIcapCardHeader;
